var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-bar"},_vm._l((_vm.topbarList),function(item){return _c('router-link',{key:item.name,staticClass:"bar-item",class:{
      active: item.isActive,
      disabled: item.isDisabled,
    },attrs:{"to":item.isDisabled ? '' : item.path}},[_vm._v(_vm._s(item.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }